export default {
    access: true,
    bonification: false,
    occupationGroups: [],
    role: null,
    manager: null,
    modules: [],
    networks: [],
    accessPermissions: [],
    editOccupationGroups: false,
    editBonification: false,
    editAccessStatus: false,
    editRole: false,
    editManager: false,
    editModules: null,
    editNetworks: null,
    editPermissions: null,
    editNBox: false,
    editStatus: false,
}
